module.exports = __webpack_public_path__ + "static/media/blueberry_lemon.b163deef.JPG";